import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import {useAxiosIndicatorCheck} from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from "./AxiosIndicatorRunTimeLoader";

export function AxiosSingletonLoader(props) {
    const {slugKey} = props;
    const refLoad = useRef();
    const [load, setLoad] = useState(false);
    const [__check] = useAxiosIndicatorCheck();
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    useEffect(() => {
        let status = __check(slugKey).status;
        if (status === true && load === true) {
            refLoad.current.style.display = 'none';
        } else {
            refLoad.current.style.display = '';
            setLoad(false)
        }
    }, [axios_indicator, load])
    return (
        <>
            {load === true &&
            <AxiosIndicatorRunTimeLoader {...props}/>
            }
            <div ref={refLoad} onClick={() => {
                setLoad(true)
            }}>
                {props.children}
            </div>
        </>
    );
}

export default AxiosSingletonLoader;